(function () {
  var quiz = document.getElementById('lq-quiz');
  if (!quiz) return;

  var TOTAL_STEPS = 5;

  /* ─── Charte de tailles ─────────────────────── */
  var SIZE_CHART = {
    '32B':   { lil: 'XXSmall',   equiv: '32B / 34A' },
    '34A':   { lil: 'XXSmall',   equiv: '32B / 34A' },
    '34B':   { lil: 'XSmall',    equiv: '34B / 32C' },
    '32C':   { lil: 'XSmall',    equiv: '34B / 32C' },
    '32DD':  { lil: 'XSmall+',   equiv: '32DD' },
    '36A':   { lil: 'Small-',    equiv: '36A' },
    '34C':   { lil: 'Small',     equiv: '34C / 32D' },
    '32D':   { lil: 'Small',     equiv: '34C / 32D' },
    '34DD':  { lil: 'Small+',    equiv: '34DD / 32DDD' },
    '32DDD': { lil: 'Small+',    equiv: '34DD / 32DDD' },
    '32G':   { lil: 'Small++',   equiv: '32G' },
    '36B':   { lil: 'Medium-',   equiv: '36B' },
    '34D':   { lil: 'Medium',    equiv: '34D / 36C' },
    '36C':   { lil: 'Medium',    equiv: '34D / 36C' },
    '34DDD': { lil: 'Medium+',   equiv: '34DDD / 36DD' },
    '36DD':  { lil: 'Medium+',   equiv: '34DDD / 36DD' },
    '34G':   { lil: 'Medium++',  equiv: '34G' },
    '38B':   { lil: 'Large-',    equiv: '38B' },
    '36D':   { lil: 'Large',     equiv: '36D / 38C' },
    '38C':   { lil: 'Large',     equiv: '36D / 38C' },
    '36DDD': { lil: 'Large+',    equiv: '36DDD / 38DD' },
    '38DD':  { lil: 'Large+',    equiv: '36DDD / 38DD' },
    '40B':   { lil: 'XLarge-',   equiv: '40B' },
    '38D':   { lil: 'XLarge',    equiv: '38D' },
    '38DDD': { lil: 'XLarge+',   equiv: '38DDD' },
    '42B':   { lil: 'XXLarge-',  equiv: '42B' },
    '40D':   { lil: 'XXLarge',   equiv: '40D / 42C' },
    '42C':   { lil: 'XXLarge',   equiv: '40D / 42C' },
    '40DDD': { lil: 'XXLarge+',  equiv: '40DDD' },
    '40DD':  { lil: 'XXXLarge',  equiv: '40DD / 42D' },
    '42D':   { lil: 'XXXLarge',  equiv: '40DD / 42D' }
  };

  var state = {
    step: 1,
    taille: '',
    bonnet: '',
    style: '',
    coupe: '',
    types: [],
    priorites: [],
    email: '',
    phone: '',
    lil: null,      // taille Lil trouvée par le calculateur
    mesures: null   // { underbust, bust, ajustement } saisis dans le calculateur
  };

  /* ─── Progress ─────────────────────────────── */
  function updateProgress(n) {
    var fill  = document.getElementById('lq-progress-fill');
    var label = document.getElementById('lq-progress-label');
    if (fill)  fill.style.width = Math.round((n / TOTAL_STEPS) * 100) + '%';
    if (label) label.textContent = n + ' / ' + TOTAL_STEPS;
  }

  /* ─── Step navigation ───────────────────────── */
  function setStep(n) {
    document.querySelectorAll('.lq-step').forEach(function (el) {
      el.classList.remove('is-active');
    });

    if (n === 'results') {
      var r = document.getElementById('lq-results');
      if (r) r.classList.add('is-active');
      var prog = document.querySelector('.lq-progress');
      if (prog) prog.style.display = 'none';
      return;
    }

    state.step = n;
    var el = document.getElementById('lq-step-' + n);
    if (el) el.classList.add('is-active');
    updateProgress(n);
    window.scrollTo({ top: quiz.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
  }

  /* ─── Public nav functions ──────────────────── */
  window.lqNext = function (from) {
    if (from === 1) {
      var taille = (document.getElementById('lq-tour').value  || '').trim();
      var bonnet = (document.getElementById('lq-bonnet').value || '').trim();
      if (!taille || !bonnet) {
        // Taille déjà trouvée avec le calculateur (retour depuis l'étape 2)
        if (!taille && !bonnet && state.lil) { setStep(2); return; }
        if (!taille) { shake(document.getElementById('lq-tour').closest('.lq-size-group')); markSelectError(document.getElementById('lq-tour')); }
        if (!bonnet) { shake(document.getElementById('lq-bonnet').closest('.lq-size-group')); markSelectError(document.getElementById('lq-bonnet')); }
        return;
      }
      state.taille = taille;
      state.bonnet = bonnet;
      state.lil = null;
      state.mesures = null;
      setStep(2);
    } else if (from === 2) {
      var checked = document.querySelector('input[name="lq-style"]:checked');
      if (!checked) { shake(document.querySelector('.lq-image-cards')); return; }
      state.style = checked.value;
      console.log('[Quiz] Q2 style:', state.style);
      setStep(3);
    } else if (from === 3) {
      var checkedCoupe = document.querySelector('input[name="lq-coupe"]:checked');
      if (!checkedCoupe) { shake(document.getElementById('lq-coupe-cards')); return; }
      state.coupe = checkedCoupe.value;
      console.log('[Quiz] Q3 coupe:', state.coupe);
      setStep(4);
    } else if (from === 4) {
      var priorites = selectedPills('lq-priorites-pills');
      if (!priorites.length) { shake(document.getElementById('lq-priorites-pills')); return; }
      state.priorites = priorites;
      console.log('[Quiz] Q4 priorites:', state.priorites);
      setStep(5);
    }
  };

  function markSelectError(el) {
    if (!el) return;
    el.style.borderColor = '#c0392b';
    el.addEventListener('change', function () { el.style.borderColor = ''; }, { once: true });
  }

  window.lqBack = function (from) { setStep(from - 1); };

  function shake(el) {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = 'lq-shake 0.45s ease';
    setTimeout(function () { el.style.animation = ''; }, 500);
  }

  /* ─── Pill buttons ──────────────────────────── */
  function selectedPills(containerId) {
    return Array.from(
      document.querySelectorAll('#' + containerId + ' .lq-pill.is-selected')
    ).map(function (p) { return p.dataset.value; });
  }

  function bindPills(containerId, max) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('.lq-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var on = pill.classList.contains('is-selected');
        if (!on && max) {
          var cur = container.querySelectorAll('.lq-pill.is-selected').length;
          if (cur >= max) {
            container.querySelector('.lq-pill.is-selected').classList.remove('is-selected');
          }
        }
        pill.classList.toggle('is-selected', !on);
      });
    });
  }

  bindPills('lq-types-pills', null);
  bindPills('lq-priorites-pills', 1);

  /* ─── Image-card radio (Q2, Q3) ─────────────── */
  document.querySelectorAll('.lq-image-card').forEach(function (card) {
    card.addEventListener('click', function () {
      var container = card.closest('.lq-image-cards');
      if (container) {
        container.querySelectorAll('.lq-image-card').forEach(function (c) {
          c.classList.remove('is-selected');
        });
      }
      card.classList.add('is-selected');
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });

  /* ─── Tab switch (lead capture) ─────────────── */
  window.lqSwitchTab = function (tab) {
    document.querySelectorAll('.lq-capture__tab').forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.tab === tab);
    });
    document.querySelectorAll('.lq-capture__field').forEach(function (f) {
      f.classList.remove('is-active');
    });
    var field = document.getElementById('lq-field-' + tab);
    if (field) field.classList.add('is-active');
  };

  /* ─── Submit (step 5) ───────────────────────── */
  window.lqSubmit = function () {
    var emailInput = document.getElementById('lq-email');
    var phoneInput = document.getElementById('lq-phone');
    var errorEl    = document.getElementById('lq-capture-error');
    var submitBtn  = document.getElementById('lq-submit-btn');

    var email = (emailInput ? emailInput.value : '').trim();
    var phone = (phoneInput ? phoneInput.value : '').trim();

    var emailOk = email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    var phoneOk = phone && phone.replace(/\D/g, '').length >= 8;

    if (!emailOk && !phoneOk) {
      if (errorEl) errorEl.classList.add('is-visible');
      if (emailInput) emailInput.classList.add('is-error');
      return;
    }
    if (errorEl)    errorEl.classList.remove('is-visible');
    if (emailInput) emailInput.classList.remove('is-error');
    if (phoneInput) phoneInput.classList.remove('is-error');

    state.email = emailOk ? email : '';
    state.phone = phoneOk ? phone : '';
    state.result = resolveCollection();

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Un moment…'; }

    sendToKlaviyo(state);

    setTimeout(function () {
      setStep('results');
      loadResults(state.result);
    }, 700);
  };

  /* ─── Result collection ─────────────────────── */
  function resolveCollection() {
    var style    = state.style;
    var coupe    = state.coupe;
    var maintien = state.priorites[0] || '';

    var map = {
      'confortable|couvrant|maintien-renforce': 'ensembles-du-quotidien-copie',
      'confortable|couvrant|maintien-leger':    'ensembles-du-quotidien-maintien-optimal-tailles-petites-a-moyenne-copie',
      'confortable|demi-buste|maintien-leger':  'ensembles-du-quotidien-maintien-leger-tailles-petites-a-moyenne-copie-copie',
      'audacieuse|couvrant|maintien-leger':     'luxueux-maintien-optimal-couvrance-leger-tailles-petites-a-moyennes-copie',
      'audacieuse|couvrant|maintien-renforce':  'luxueux-maintien-optimal-couvrance-leger-tailles-petites-a-moyennes-copie',
      'audacieuse|demi-buste|maintien-leger':   'luxueux-maintien-leger-tailles-petites-a-moyennes-copie',
      'confortable|demi-buste|maintien-renforce': 'ensembles-du-quotidien-maintien-optimal-tailles-moyenne-a-forte-copie',
      'audacieuse|demi-buste|maintien-renforce':  'luxueux-maintien-optimal-tailles-moyennes-a-fortes-copie'
    };

    var key = style + '|' + coupe + '|' + maintien;
    /* eslint-disable no-console */
    console.log('[Quiz] resolveCollection key:', key, '→', map[key] || '(no match)');
    return (map[key] || 'most-confortable-collection').trim();
  }

  /* ─── Load results ──────────────────────────── */
  function loadResults(handle) {
    var loading = document.getElementById('lq-results-loading');
    var content = document.getElementById('lq-results-content');
    var grid    = document.getElementById('lq-results-grid');
    var cta     = document.getElementById('lq-results-cta');

    if (loading) {
      loading.innerHTML =
        '<div class="lq-spinner">' +
        '<svg width="38" height="38" viewBox="0 0 38 38">' +
        '<circle cx="19" cy="19" r="15" stroke="#e8e0d8" stroke-width="3" fill="none"/>' +
        '<circle cx="19" cy="19" r="15" stroke="#1a1a1a" stroke-width="3" fill="none"' +
        ' stroke-dasharray="52 68" stroke-linecap="round"/>' +
        '</svg></div>';
    }

    if (cta) {
      cta.href = '/collections/new';
      cta.textContent = 'Nouveautés →';
    }

    if (!handle) {
      if (loading) loading.style.display = 'none';
      showSizeResult();
      if (content) content.style.display = '';
      return;
    }

    fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) {
          if (loading) loading.style.display = 'none';
          showSizeResult();
          if (content) content.style.display = '';
          return;
        }

        var cards = products.map(function (p) {
          var img    = p.images && p.images[0] ? p.images[0].src : '';
          var price  = p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
          var compare = p.variants && p.variants[0] ? parseFloat(p.variants[0].compare_at_price) : 0;
          var priceHtml = compare && compare > price
            ? '<s class="lq-card__compare">$' + compare.toFixed(2) + '</s> <span class="lq-card__price lq-card__price--sale">$' + price.toFixed(2) + '</span>'
            : '<span class="lq-card__price">$' + price.toFixed(2) + '</span>';
          return '<a href="/products/' + esc(p.handle) + '" class="lq-card">' +
            (img ? '<img class="lq-card__img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
            '<div class="lq-card__info"><p class="lq-card__title">' + esc(p.title) + '</p>' +
            '<p class="lq-card__prices">' + priceHtml + '</p></div>' +
            '</a>';
        });

        if (loading) loading.style.display = 'none';
        if (grid) grid.innerHTML = cards.join('');
        showSizeResult();
        if (content) content.style.display = '';
      })
      .catch(function () {
        if (loading) loading.style.display = 'none';
        showSizeResult();
        if (content) content.style.display = '';
      });
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ─── Klaviyo ───────────────────────────────── */
  function sendToKlaviyo(s) {
    var apiKey = (quiz.dataset.klaviyoKey  || '').trim();
    var listId = (quiz.dataset.klaviyoList || '').trim();

    var chartMatch = SIZE_CHART[s.taille + s.bonnet];
    var tailleLil  = s.lil ? s.lil.name : (chartMatch ? chartMatch.lil : '');

    var profileProps = {};
    if (s.taille)           profileProps['Quiz_Taille']    = s.taille + s.bonnet;
    if (tailleLil)          profileProps['Quiz_Taille_Lil'] = tailleLil;
    if (s.mesures) {
      profileProps['Quiz_Tour_Dessous_Poitrine'] = s.mesures.underbust;
      profileProps['Quiz_Tour_Poitrine']         = s.mesures.bust;
      if (s.mesures.ajustement) profileProps['Quiz_Ajustement'] = s.mesures.ajustement;
    }
    if (s.style)            profileProps['Quiz_Style']     = s.style;
    if (s.coupe)            profileProps['Quiz_Coupe']     = s.coupe;
    if (s.types.length)     profileProps['Quiz_Types']     = s.types.join(', ');
    if (s.priorites.length) profileProps['Quiz_Priorites'] = s.priorites.join(', ');
    if (s.result)           profileProps['Quiz_Resultat']  = s.result;

    var identify = Object.assign({ '$email': s.email || undefined, '$phone_number': s.phone || undefined }, profileProps);
    Object.keys(identify).forEach(function (k) { if (!identify[k]) delete identify[k]; });

    /* Method 1: Klaviyo JS SDK (_learnq) — works when Klaviyo app is installed */
    if (window._learnq) {
      window._learnq.push(['identify', identify]);
      window._learnq.push(['track', 'Quiz Parure Complété', {
        taille:    s.taille + s.bonnet,
        taille_lil: tailleLil,
        mesures:   s.mesures,
        style:     s.style,
        types:     s.types,
        priorites: s.priorites,
        resultat:  s.result
      }]);
    }

    /* Method 2: Klaviyo Client API (public key only, CORS-safe) */
    if (!apiKey) return;
    var base    = 'https://a.klaviyo.com/client/';
    var qp      = '?company_id=' + encodeURIComponent(apiKey);
    var headers = { 'Content-Type': 'application/vnd.api+json', 'revision': '2023-02-22' };

    /* Create / update profile */
    var profileAttrs = Object.assign({}, profileProps);
    if (s.email) profileAttrs.email        = s.email;
    if (s.phone) profileAttrs.phone_number = s.phone;

    fetch(base + 'profiles/' + qp, {
      method: 'POST', headers: headers,
      body: JSON.stringify({ data: { type: 'profile', attributes: profileAttrs } })
    }).catch(function () {});

    /* Subscribe to list */
    if (listId) {
      var subAttrs = { list_id: listId, custom_source: 'Quiz Parure Lil' };
      if (s.email) subAttrs.email        = s.email;
      if (s.phone) subAttrs.phone_number = s.phone;
      fetch(base + 'subscriptions/' + qp, {
        method: 'POST', headers: headers,
        body: JSON.stringify({ data: { type: 'subscription', attributes: subAttrs } })
      }).catch(function () {});
    }

    /* Track event */
    var custProfile = {};
    if (s.email) custProfile.email        = s.email;
    if (s.phone) custProfile.phone_number = s.phone;
    fetch(base + 'events/' + qp, {
      method: 'POST', headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Quiz Parure Complété' } } },
            profile: { data: { type: 'profile', attributes: custProfile } },
            properties: {
              taille:    s.taille + s.bonnet,
              taille_lil: tailleLil,
              mesures:   s.mesures,
              style:     s.style,
              types:     s.types,
              priorites: s.priorites,
              resultat:  s.result
            }
          }
        }
      })
    }).catch(function () {});
  }

  /* ─── Restart ───────────────────────────────── */
  window.lqRestart = function () {
    state = { step: 1, taille: '', bonnet: '', style: '', coupe: '', types: [], priorites: [], email: '', phone: '', lil: null, mesures: null };
    window.lqCalcReset();
    var calcU = document.getElementById('lq-calc-underbust');
    var calcB = document.getElementById('lq-calc-bust');
    if (calcU) calcU.value = '';
    if (calcB) calcB.value = '';

    var tour   = document.getElementById('lq-tour');
    var bonnet = document.getElementById('lq-bonnet');
    var email  = document.getElementById('lq-email');
    var phone  = document.getElementById('lq-phone');
    var btn    = document.getElementById('lq-submit-btn');

    if (tour)   tour.value   = '';
    if (bonnet) bonnet.value = '';
    if (email)  email.value  = '';
    if (phone)  phone.value  = '';
    if (btn)  { btn.disabled = false; btn.textContent = 'Découvrir mes recommandations'; }

    document.querySelectorAll('.lq-image-card').forEach(function (c) { c.classList.remove('is-selected'); });
    document.querySelectorAll('input[name="lq-style"]').forEach(function (r) { r.checked = false; });
    document.querySelectorAll('input[name="lq-coupe"]').forEach(function (r) { r.checked = false; });
    document.querySelectorAll('.lq-pill').forEach(function (p) { p.classList.remove('is-selected'); });

    var loading  = document.getElementById('lq-results-loading');
    var content  = document.getElementById('lq-results-content');
    var grid     = document.getElementById('lq-results-grid');
    var sizeCard = document.getElementById('lq-size-result');
    if (loading)  { loading.innerHTML = ''; loading.style.display = ''; }
    if (content)  content.style.display = 'none';
    if (grid)     grid.innerHTML = '';
    if (sizeCard) sizeCard.style.display = 'none';

    var prog = document.querySelector('.lq-progress');
    if (prog) prog.style.display = '';

    setStep(1);
  };

  /* ─── Size result (shown on results page) ───── */
  function showSizeResult() {
    var key   = state.taille + state.bonnet;
    var match = state.lil ? { lil: state.lil.name, equiv: state.lil.equiv } : SIZE_CHART[key];
    var card  = document.getElementById('lq-size-result');
    if (!card) return;
    if (!match) { card.style.display = 'none'; return; }
    var lilEl   = document.getElementById('lq-size-lil');
    var equivEl = document.getElementById('lq-size-equiv');
    if (lilEl)   lilEl.textContent   = match.lil;
    if (equivEl) equivEl.textContent = match.equiv;
    if (equivEl) equivEl.parentNode.style.display = match.equiv ? '' : 'none';
    card.style.display = '';
  }

  /* ─── Calculateur de taille (mesures en pouces) ─
     tour : taille de base (S, M, L…) ; cup : bonnet (colonne « Construction »).
     La question d'ajustement départage deux tours voisins par le bonnet
     (ajusté / sculptant = bonnet le plus petit, relax = bonnet le plus grand) ;
     les +, ++ et – sont choisis automatiquement. */
  var MEASURE_CHART = [
    { tour: 'XXS', mod: '',   u: [27, 29],     b: [30, 33], cup: 'XXS' },
    { tour: 'XS',  mod: '',   u: [28, 30],     b: [31, 34], cup: 'XS' },
    { tour: 'S',   mod: '-',  u: [29.5, 31.5], b: [32, 34], cup: 'XXS' },
    { tour: 'S',   mod: '',   u: [29.5, 31.5], b: [34, 36], cup: 'S' },
    { tour: 'S',   mod: '+',  u: [29.5, 31.5], b: [37, 40], cup: 'L' },
    { tour: 'S',   mod: '++', u: [29.5, 31.5], b: [40, 43], cup: 'XL' },
    { tour: 'M',   mod: '-',  u: [30, 32.5],   b: [34, 36], cup: 'XS' },
    { tour: 'M',   mod: '',   u: [30, 32.5],   b: [36, 39], cup: 'M' },
    { tour: 'M',   mod: '+',  u: [30, 32.5],   b: [40, 43], cup: 'XL' },
    { tour: 'M',   mod: '++', u: [30, 32.5],   b: [43, 47], cup: '2XL' },
    { tour: 'L',   mod: '-',  u: [32, 36],     b: [36, 39], cup: 'S' },
    { tour: 'L',   mod: '',   u: [32, 36],     b: [39, 42], cup: 'L' },
    { tour: 'L',   mod: '+',  u: [34, 36],     b: [43, 47], cup: '2XL' },
    { tour: 'L',   mod: '++', u: [34, 36],     b: [46, 50], cup: '3XL' },
    { tour: 'XL',  mod: '-',  u: [35, 44.5],   b: [39, 42], cup: 'M' },
    { tour: 'XL',  mod: '',   u: [35, 44.5],   b: [42, 48], cup: 'XL' },
    { tour: 'XL',  mod: '+',  u: [35, 44.5],   b: [46, 50], cup: '3XL' },
    { tour: '2XL', mod: '-',  u: [40, 44.5],   b: [42, 46], cup: 'L' },
    { tour: '2XL', mod: '',   u: [40, 44.5],   b: [45, 49], cup: '2XL' },
    { tour: '2XL', mod: '+',  u: [40, 44.5],   b: [49, 53], cup: '4XL' },
    { tour: '3XL', mod: '-',  u: [41, 45],     b: [45, 48], cup: 'XL' },
    { tour: '3XL', mod: '',   u: [41, 45],     b: [48, 52], cup: '3XL' },
    { tour: '3XL', mod: '+',  u: [41, 45],     b: [52, 56], cup: '4XL' }
  ];
  var TOUR_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
  var CUP_ORDER  = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  var TOUR_NAMES = { XXS: 'XXSmall', XS: 'XSmall', S: 'Small', M: 'Medium', L: 'Large', XL: 'XLarge', '2XL': 'XXLarge', '3XL': 'XXXLarge' };
  // Écart max. (en pouces, hors des plages) pour proposer quand même la taille la plus proche
  var MAX_GAP = 2;

  // Tailles de soutien-gorge équivalentes, reprises de la charte ci-dessus
  var LIL_EQUIV = {};
  Object.keys(SIZE_CHART).forEach(function (k) { LIL_EQUIV[SIZE_CHART[k].lil] = SIZE_CHART[k].equiv; });

  var calc = { u: null, b: null, candidates: [], result: null, fit: '', approx: false };

  function lilName(row) { return TOUR_NAMES[row.tour] + row.mod; }
  function mid(r) { return (r[0] + r[1]) / 2; }
  function outside(v, r) { return v < r[0] ? r[0] - v : (v > r[1] ? v - r[1] : 0); }

  // Dans un même tour : la taille de base si b est dans sa plage (limites incluses),
  // sinon la plage de poitrine [min, max) qui contient b, sinon la plus proche
  function pickInTour(rows, b) {
    var base = rows.filter(function (r) { return r.mod === '' && b >= r.b[0] && b <= r.b[1]; })[0];
    if (base) return base;
    var inside = rows.filter(function (r) { return b >= r.b[0] && b < r.b[1]; });
    var pool = inside.length ? inside : rows;
    return pool.slice().sort(function (x, y) { return Math.abs(b - mid(x.b)) - Math.abs(b - mid(y.b)); })[0];
  }

  // Une taille par tour, triées de la plus petite à la plus grande
  function findCandidates(u, b) {
    var scored = MEASURE_CHART.map(function (row) { return { row: row, gap: outside(u, row.u) + outside(b, row.b) }; });
    var best = Math.min.apply(null, scored.map(function (s) { return s.gap; }));
    calc.approx = best > 0;
    if (best > MAX_GAP) return [];
    var byTour = {};
    scored.forEach(function (s) {
      if (s.gap !== best) return;
      (byTour[s.row.tour] = byTour[s.row.tour] || []).push(s.row);
    });
    return TOUR_ORDER.filter(function (t) { return byTour[t]; })
      .map(function (t) { return pickInTour(byTour[t], b); });
  }

  function parseInches(el) {
    var v = parseFloat(String(el.value || '').replace(',', '.').replace(/[^\d.]/g, ''));
    return isNaN(v) ? null : v;
  }

  function showCalcPanel(id) {
    ['lq-calc-form', 'lq-calc-fit', 'lq-calc-result'].forEach(function (p) {
      var el = document.getElementById(p);
      if (el) el.classList.toggle('is-active', p === id);
    });
  }

  function renderCalcTable() {
    var tbody = document.getElementById('lq-calc-table');
    if (!tbody) return;
    var fmt = function (r) { return String(r[0]).replace('.', ',') + '–' + String(r[1]).replace('.', ',') + '″'; };
    tbody.innerHTML = MEASURE_CHART.map(function (row) {
      return '<tr><td>' + esc(row.tour + row.mod) + '</td><td>' + fmt(row.u) + '</td><td>' + fmt(row.b) + '</td></tr>';
    }).join('');
  }

  window.lqOpenCalc = function () {
    var modal = document.getElementById('lq-calc');
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('lq-calc-open');
    var first = document.getElementById('lq-calc-underbust');
    if (first && calc.result === null) first.focus();
  };

  window.lqCloseCalc = function () {
    var modal = document.getElementById('lq-calc');
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove('lq-calc-open');
  };

  document.addEventListener('keydown', function (e) {
    var modal = document.getElementById('lq-calc');
    if (e.key === 'Escape' && modal && !modal.hidden) window.lqCloseCalc();
  });

  window.lqCalcSubmit = function () {
    var uEl = document.getElementById('lq-calc-underbust');
    var bEl = document.getElementById('lq-calc-bust');
    var errorEl = document.getElementById('lq-calc-error');
    var u = parseInches(uEl);
    var b = parseInches(bEl);
    var error = '';

    if (u === null || u < 20 || u > 60) error = 'Entrez votre tour de dessous de poitrine en pouces (ex. 31).';
    else if (b === null || b < 20 || b > 70) error = 'Entrez votre tour de poitrine en pouces (ex. 36).';
    else if (b <= u) error = 'Le tour de poitrine doit être plus grand que le tour de dessous de poitrine.';

    if (errorEl) errorEl.textContent = error;
    if (error) { shake(document.querySelector('.lq-calc__fields')); return; }

    calc.u = u;
    calc.b = b;
    calc.fit = '';
    calc.candidates = findCandidates(u, b);

    // Question posée à toutes ; elle ne change le résultat que s'il y a deux tailles possibles
    if (calc.candidates.length) { showCalcPanel('lq-calc-fit'); return; }
    showCalcResult(null);
  };

  window.lqCalcFit = function (fit) {
    var c = calc.candidates;
    calc.fit = fit;
    // Toujours entre les deux plus petits tours possibles (ex. 43/49 → XL+ ou 2XL, même si 3XL
    // correspond aussi), départagés par le bonnet ; à bonnet égal, le plus petit tour est le plus ajusté
    var pair = c.slice(0, 2).sort(function (x, y) {
      return (CUP_ORDER.indexOf(x.cup) - CUP_ORDER.indexOf(y.cup)) || (TOUR_ORDER.indexOf(x.tour) - TOUR_ORDER.indexOf(y.tour));
    });
    showCalcResult(fit === 'ajuste' ? pair[0] : pair[pair.length - 1]);
  };

  function showCalcResult(row) {
    var sizeEl  = document.getElementById('lq-calc-size');
    var lilEl   = document.getElementById('lq-calc-lil');
    var equivEl = document.getElementById('lq-calc-equiv');
    var noteEl  = document.getElementById('lq-calc-note');
    var useBtn  = document.getElementById('lq-calc-use');

    if (!row) {
      calc.result = null;
      if (sizeEl) sizeEl.style.display = 'none';
      if (useBtn) useBtn.style.display = 'none';
      if (noteEl) noteEl.textContent = 'Vos mesures sont hors de notre charte des tailles. Contactez nos expertes via le clavardage en ligne : elles vous aideront à trouver votre taille.';
      showCalcPanel('lq-calc-result');
      return;
    }

    var name = lilName(row);
    calc.result = { code: row.tour + row.mod, name: name, equiv: LIL_EQUIV[name] || '' };

    if (sizeEl)  sizeEl.style.display = '';
    if (useBtn)  useBtn.style.display = '';
    if (lilEl)   lilEl.textContent = name;
    if (equivEl) {
      equivEl.textContent = calc.result.equiv ? 'Tailles équivalentes : ' + calc.result.equiv : '';
      equivEl.style.display = calc.result.equiv ? '' : 'none';
    }
    if (noteEl) {
      noteEl.textContent = calc.approx
        ? 'Vos mesures se situent entre deux tailles de notre charte : voici la plus proche. Au besoin, nos expertes peuvent vous conseiller via le clavardage.'
        : '';
    }
    showCalcPanel('lq-calc-result');
  }

  window.lqCalcReset = function () {
    calc = { u: null, b: null, candidates: [], result: null, fit: '', approx: false };
    var errorEl = document.getElementById('lq-calc-error');
    if (errorEl) errorEl.textContent = '';
    showCalcPanel('lq-calc-form');
  };

  window.lqCalcUse = function () {
    if (!calc.result) return;
    state.lil = calc.result;
    state.mesures = { underbust: calc.u, bust: calc.b, ajustement: calc.fit };
    state.taille = '';
    state.bonnet = '';
    var tour = document.getElementById('lq-tour');
    var bonnet = document.getElementById('lq-bonnet');
    if (tour) tour.value = '';
    if (bonnet) bonnet.value = '';
    window.lqCloseCalc();
    setStep(2);
  };

  /* ─── Init ──────────────────────────────────── */
  renderCalcTable();
  updateProgress(1);
})();
